import React, { useState } from 'react';
import logo from '../assets/images/Saha Logo_nobg.png'
const Footer = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const scrollToSection = (section) => {
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    // Close navbar after clicking a link (for mobile view)
    setIsNavOpen(false);
  };
  return (
    <div id='Footer'>
      <section>
        <div className="call-out">
          <div className="container">
            <div className="row">
              <div className="col-md-3 col-sm-12">
                <figure className="logo" >
                  <img src={logo} alt="logo" style={{height:'130px'}} className='img-fluid' />
                </figure>
              </div>
              <div className="col-md-9 col-sm-12">
                <div className="text-center">
                  <h4 style={{fontSize:'30px',color:'white',marginTop:'60px'}}>Building the Future of Technology, Together.</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Section */}
        <footer className="main-footer">
          {/* Widgets Section */}
          <div className="widgets-section">
            <div className="container">
              <div className="row">
                {/* Big Column */}
                <div className="big-column col-md-8 col-sm-12 col-xs-12">
                  <div className="row clearfix">
                    {/* Footer Column */}
                    {/* <div className="footer-column col-md-6 col-sm-6 col-xs-12">
                      <div className="footer-widget about-widget">
                        <h3 className="footer-title">About Us</h3>
                        <div className="widget-content">
                          <div className="text">
                            <p>
                            At our IT Consulting Company, we specialize in helping clients meet their technology needs through personalized, innovative solutions. Our goal is to bridge the gap between businesses and technology by providing skilled professionals to fill open positions.
                            </p>
                          </div>
                       
                        </div>
                      </div>
                    </div> */}
                      <div className="footer-column col-md-6 col-sm-6 col-xs-12">
                      <div className="footer-widget links-widget">
                        <h3 className="footer-title">Quick Links</h3>
                        <div className="widget-content">
                        <ul className="list">
        <li>
          <a className="nav-link active" href="/#Home">
            Home
          </a>
        </li>
        <li>
          <a className="nav-link" href="/#About" onClick={() => scrollToSection('About')}>
            About Us
          </a>
        </li>
        <li>
          <a className="nav-link" href="/#Services" onClick={() => scrollToSection('Services')}>
            Services
          </a>
        </li>
        <li>
          <a className="nav-link" href="/#Contact" onClick={() => scrollToSection('Contact')}>
            Contact Us
          </a>
        </li>
      </ul>
                        </div>
                      </div>
                    </div>
                    {/* Footer Column */}
                    <div className="footer-column col-md-6 col-sm-6 col-xs-12">
                      <div className="footer-widget links-widget">
                        <h3 className="footer-title">Our Services</h3>
                        <div className="widget-content">
                          <ul className="list">
                            <li>Talent Acquisition & Staffing</li>
                            <li>Training & Skill Development</li>
                            <li>Technical Support & Troubleshooting</li>
                            <li>IT Strategy Consulting</li>                            
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Big Column */}
                <div className="big-column col-md-4 col-sm-12 col-xs-12">
                  <div className="row clearfix">
                    {/* Footer Column */}
                    <div className="footer-column col-md-12 col-sm-12 col-xs-12">
                      <div className="footer-widget contact-widget">
                        <h3 className="footer-title">Contact us</h3>
                        <div className="widget-content">
                          <ul className="contact-info">
                            <li>
                              <i className="fa fa-map"></i>1301 Friscohills blvd, Little ELM, <br />
                              TX. 75068.
                            </li>
                            {/* <li>
                              <i className="fa fa-phone"></i> Phone: +123-456-7890
                            </li> */}
                            <li>
                              <i className="fa fa-envelope"></i>info@sahainfotechs.com
                            </li>
                          </ul>
                        </div>
                        <ul className="social">
                          <li>
                          <a href="#" ><i className="fab fa-facebook-f" style={{color:'#48c7ec',marginRight:'20px'}}></i></a>                        
                          <a href="#" className="ms-2"><i className="fab fa-linkedin-in" style={{color:'#48c7ec',marginRight:'20px'}}></i></a>                    
                          <a href="#" className="ms-2"><i className="fab fa-twitter" style={{color:'#48c7ec',marginRight:'20px'}}></i></a>
                         
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer Bottom */}
          <section className="footer-bottom">
            <div className="container d-flex justify-content-between align-items-center">
              <div className="copy-text">
                <p>Copyrights © 2025 All Rights Reserved. Powered by SAHA INFOTECHS</p>
              </div>
              <div className="get-text">
                <ul className="d-flex">
                  <li>Support | </li>
                  <li>Privacy &amp; Policy |</li>
                  <li>Terms &amp; Conditions</li>
                </ul>
              </div>
            </div>
          </section>
        </footer>
      </section>
    </div>
  );
};

export default Footer;
